module.exports = __webpack_public_path__ + "img/pay-bar.913359b7.png";